export enum FiltersEnum {
  VOICEMAIL = 'voicemail',
  NO_ANSWER = 'no_answer',
  CUT_OFF = 'cut_off',
  TRANSFER_ERROR = 'transfer_error',
  FLAGGED = 'flagged',
}
